// Initialize Interview Panels Recent Slider
(function() {
    'use strict';

    let interviewPanelsRecentSwiper = null;
    let initAttempts = 0;
    const maxAttempts = 20;

    function initInterviewPanelsRecentSlider(resetAttempts) {
        if (resetAttempts) {
            initAttempts = 0;
        }
        initAttempts++;

        // Wait for Swiper to be available
        if (typeof Swiper === 'undefined') {
            if (initAttempts < maxAttempts) {
                setTimeout(function() {
                    initInterviewPanelsRecentSlider(false);
                }, 100);
            } else {
                console.error('Swiper failed to load after multiple attempts');
            }
            return;
        }

        // Initialize interview panels recent slider
        const interviewPanelsRecentSection = document.querySelector('.interview-panels-recent');
        if (!interviewPanelsRecentSection) {
            if (initAttempts < maxAttempts) {
                setTimeout(function() {
                    initInterviewPanelsRecentSlider(false);
                }, 100);
            }
            return;
        }

        const slider = interviewPanelsRecentSection.querySelector('.interview-panels-recent__slider');
        const prevBtn = interviewPanelsRecentSection.querySelector('.interview-panels-recent__nav-btn--prev');
        const nextBtn = interviewPanelsRecentSection.querySelector('.interview-panels-recent__nav-btn--next');

        if (!slider) {
            return;
        }

        // Check if slider already has slides
        const slides = slider.querySelectorAll('.swiper-slide');
        if (slides.length === 0) {
            return;
        }

        // Destroy existing instance if any
        if (slider.swiper) {
            slider.swiper.destroy(true, true);
            interviewPanelsRecentSwiper = null;
        }

        try {
            interviewPanelsRecentSwiper = new Swiper(slider, {
                slidesPerView: 1.05,
                spaceBetween: 24,
                loop: false,
                speed: 600,
                grabCursor: true,
                watchOverflow: true,
                allowTouchMove: true,
                navigation: {
                    nextEl: nextBtn,
                    prevEl: prevBtn,
                    disabledClass: 'interview-panels-recent__nav-btn--disabled',
                },
                breakpoints: {
                    320: {
                        slidesPerView: 1.15,
                        spaceBetween: 16,
                    },
                    768: {
                        slidesPerView: 1.12,
                        spaceBetween: 24,
                    },
                    992: {
                        slidesPerView: 1.12,
                        spaceBetween: 140,
                    },
                },
                on: {
                    init: function() {
                        updateNavButtons();
                    },
                    slideChange: function() {
                        updateNavButtons();
                    },
                    reachEnd: function() {
                        updateNavButtons();
                    },
                    reachBeginning: function() {
                        updateNavButtons();
                    },
                },
            });

            function updateNavButtons() {
                if (!interviewPanelsRecentSwiper) return;

                if (prevBtn) {
                    if (interviewPanelsRecentSwiper.isBeginning) {
                        prevBtn.classList.add('interview-panels-recent__nav-btn--disabled');
                        prevBtn.disabled = true;
                    } else {
                        prevBtn.classList.remove('interview-panels-recent__nav-btn--disabled');
                        prevBtn.disabled = false;
                    }
                }
                if (nextBtn) {
                    if (interviewPanelsRecentSwiper.isEnd) {
                        nextBtn.classList.add('interview-panels-recent__nav-btn--disabled');
                        nextBtn.disabled = true;
                    } else {
                        nextBtn.classList.remove('interview-panels-recent__nav-btn--disabled');
                        nextBtn.disabled = false;
                    }
                }
            }
        } catch (error) {
            console.error('Error initializing interview panels recent slider:', error);
        }
    }

    // Make function globally available
    window.initInterviewPanelsRecentSlider = initInterviewPanelsRecentSlider;

    // Wait for window load to ensure all scripts are loaded
    if (window.addEventListener) {
        window.addEventListener('load', function() {
            setTimeout(function() {
                initInterviewPanelsRecentSlider(false);
            }, 100);
        });
    }

    // Also try when DOM is ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function() {
            setTimeout(function() {
                initInterviewPanelsRecentSlider(false);
            }, 200);
        });
    } else {
        setTimeout(function() {
            initInterviewPanelsRecentSlider(false);
        }, 200);
    }
})();

// Interview Panels Filters
(function() {
    'use strict';

    const form = document.querySelector('.blog-filters__form');
    if (!form) return;

    const interviewPanelsContent = document.querySelector('.interview-panels-content');
    if (!interviewPanelsContent) return;

    // Check if AJAX is available
    if (typeof evona === 'undefined' || !evona.ajaxUrl || !evona.interviewPanelsNonce) {
        // Fallback to regular form submission
        const selects = form.querySelectorAll('.blog-filters__select');
        selects.forEach(function(select) {
            select.addEventListener('change', function() {
                form.submit();
            });
        });

        const searchInput = form.querySelector('.blog-filters__search-input');
        if (searchInput) {
            let searchTimeout;
            searchInput.addEventListener('input', function() {
                clearTimeout(searchTimeout);
                searchTimeout = setTimeout(function() {
                    form.submit();
                }, 500);
            });

            searchInput.addEventListener('keydown', function(e) {
                if (e.key === 'Enter') {
                    e.preventDefault();
                    clearTimeout(searchTimeout);
                    form.submit();
                }
            });
        }
        return;
    }

    // Save initial content for restoration
    let initialContent = interviewPanelsContent.innerHTML;

    // Loading state
    let isLoading = false;

    /**
     * Check if filters are cleared (all default values)
     */
    function areFiltersCleared() {
        const searchInput = form.querySelector('.blog-filters__search-input');
        const categorySelect = form.querySelector('select[name="category"]');

        const searchValue = searchInput ? searchInput.value.trim() : '';
        const categoryValue = categorySelect ? categorySelect.value : '';

        return searchValue === '' && categoryValue === '';
    }

    /**
     * Perform AJAX filter request
     */
    function performFilterRequest(paged) {
        if (isLoading) return;

        const searchInput = form.querySelector('.blog-filters__search-input');
        const categorySelect = form.querySelector('select[name="category"]');

        const searchValue = searchInput ? searchInput.value.trim() : '';
        const categoryValue = categorySelect ? categorySelect.value : '';
        const pageNumber = paged || 1;

        // If filters are cleared and page is 1, restore initial content
        if (areFiltersCleared() && pageNumber === 1) {
            interviewPanelsContent.innerHTML = initialContent;
            if (typeof window.initInterviewPanelsRecentSlider === 'function') {
                window.initInterviewPanelsRecentSlider(true);
            }
            attachPaginationHandlers();
            return;
        }

        isLoading = true;
        interviewPanelsContent.style.opacity = '0.5';
        interviewPanelsContent.style.pointerEvents = 'none';

        // Prepare form data
        const formData = new FormData();
        formData.append('action', 'evona_interview_panels_filter');
        formData.append('nonce', evona.interviewPanelsNonce);
        formData.append('search', searchValue);
        formData.append('category', categoryValue);
        formData.append('paged', pageNumber);

        // Send AJAX request
        fetch(evona.ajaxUrl, {
            method: 'POST',
            body: formData,
            credentials: 'same-origin'
        })
        .then(function(response) {
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            return response.json();
        })
        .then(function(data) {
            isLoading = false;
            interviewPanelsContent.style.opacity = '1';
            interviewPanelsContent.style.pointerEvents = 'auto';

            if (data.success && data.data && data.data.content) {
                interviewPanelsContent.innerHTML = data.data.content;
                if (typeof window.initInterviewPanelsRecentSlider === 'function') {
                    // Reset attempts when reinitializing after AJAX
                    window.initInterviewPanelsRecentSlider(true);
                }
                attachPaginationHandlers();
            } else {
                console.error('AJAX error:', data);
                // Restore initial content on error
                interviewPanelsContent.innerHTML = initialContent;
                if (typeof window.initInterviewPanelsRecentSlider === 'function') {
                    window.initInterviewPanelsRecentSlider(true);
                }
                attachPaginationHandlers();
            }
        })
        .catch(function(error) {
            isLoading = false;
            interviewPanelsContent.style.opacity = '1';
            interviewPanelsContent.style.pointerEvents = 'auto';
            console.error('AJAX request failed:', error);
            // Restore initial content on error
            interviewPanelsContent.innerHTML = initialContent;
            if (typeof window.initInterviewPanelsRecentSlider === 'function') {
                window.initInterviewPanelsRecentSlider(true);
            }
            attachPaginationHandlers();
        });
    }

    /**
     * Attach click handlers to pagination links
     */
    function attachPaginationHandlers() {
        const paginationLinks = interviewPanelsContent.querySelectorAll('.interview-panels-pagination a');
        paginationLinks.forEach(function(link) {
            link.addEventListener('click', function(e) {
                e.preventDefault();
                const href = this.getAttribute('href');
                if (!href) return;

                // Extract page number from URL
                let pageNumber = 1;
                const pageMatch = href.match(/[?&]paged=(\d+)/);
                if (pageMatch) {
                    pageNumber = parseInt(pageMatch[1], 10);
                } else {
                    const pageMatch2 = href.match(/\/page\/(\d+)\//);
                    if (pageMatch2) {
                        pageNumber = parseInt(pageMatch2[1], 10);
                    }
                }

                // Scroll to top of interview panels content
                interviewPanelsContent.scrollIntoView({ behavior: 'smooth', block: 'start' });

                // Perform filter request with page number
                performFilterRequest(pageNumber);
            });
        });
    }

    /**
     * Check if viewport is mobile (match job-board breakpoint)
     */
    function isMobileView() {
        return typeof window !== 'undefined' && window.innerWidth <= 782;
    }

    /**
     * Create mobile overlay and bottom-sheet (one per form)
     */
    function createMobileDropdownElements() {
        const container = form.closest('.blog-filters');
        if (!container || container.querySelector('.blog-filters-mobile-overlay')) {
            return null;
        }

        const overlay = document.createElement('div');
        overlay.className = 'blog-filters-mobile-overlay';
        overlay.setAttribute('aria-hidden', 'true');

        const panel = document.createElement('div');
        panel.className = 'blog-filters-mobile-dropdown';
        panel.setAttribute('aria-hidden', 'true');

        // Top SVG (white blur) – unique filter id for interview panels
        const svgTop = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        svgTop.setAttribute('class', 'blog-filters-mobile-dropdown__svg-top');
        svgTop.setAttribute('width', '375');
        svgTop.setAttribute('height', '121');
        svgTop.setAttribute('viewBox', '0 0 375 121');
        svgTop.setAttribute('fill', 'none');
        svgTop.innerHTML = '<g filter="url(#filter0_f_interview_mobile_top)"><ellipse cx="187.5" cy="0.5" rx="338.5" ry="16.5" fill="white" fill-opacity="0.3" /></g><defs><filter id="filter0_f_interview_mobile_top" x="-255" y="-120" width="885" height="241" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix" /><feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" /><feGaussianBlur stdDeviation="52" result="effect1_foregroundBlur_interview_top" /></filter></defs>';

        // Bottom SVG (blue blur) – unique filter id for interview panels
        const svgBottom = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        svgBottom.setAttribute('class', 'blog-filters-mobile-dropdown__svg-bottom');
        svgBottom.setAttribute('width', '375');
        svgBottom.setAttribute('height', '226');
        svgBottom.setAttribute('viewBox', '0 0 375 226');
        svgBottom.setAttribute('fill', 'none');
        svgBottom.innerHTML = '<g opacity="0.8" filter="url(#filter0_f_interview_mobile_bottom)" style="mix-blend-mode:plus-lighter"><ellipse cx="187" cy="304.5" rx="104.5" ry="319" transform="rotate(-90 187 304.5)" fill="#1586FF" fill-opacity="0.64" /></g><defs><filter id="filter0_f_interview_mobile_bottom" x="-332" y="0" width="1038" height="609" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix" /><feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" /><feGaussianBlur stdDeviation="100" result="effect1_foregroundBlur_interview_bottom" /></filter></defs>';

        const handle = document.createElement('div');
        handle.className = 'blog-filters-mobile-dropdown__handle';
        handle.setAttribute('aria-hidden', 'true');

        const header = document.createElement('div');
        header.className = 'blog-filters-mobile-dropdown__header';
        const titleEl = document.createElement('h3');
        titleEl.className = 'blog-filters-mobile-dropdown__title';
        titleEl.textContent = '';
        const closeBtn = document.createElement('button');
        closeBtn.type = 'button';
        closeBtn.className = 'blog-filters-mobile-dropdown__close';
        closeBtn.setAttribute('aria-label', 'Close');
        closeBtn.innerHTML = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.75684 16.243L16.2428 7.75696M16.2428 16.243L7.75684 7.75696" stroke="white" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" /></svg>';
        header.appendChild(titleEl);
        header.appendChild(closeBtn);

        const listEl = document.createElement('div');
        listEl.className = 'blog-filters-mobile-dropdown__list';

        const applyBtn = document.createElement('button');
        applyBtn.type = 'button';
        applyBtn.className = 'blog-filters-mobile-dropdown__apply';
        applyBtn.textContent = 'Apply';

        panel.appendChild(svgTop);
        panel.appendChild(svgBottom);
        panel.appendChild(handle);
        panel.appendChild(header);
        panel.appendChild(listEl);
        panel.appendChild(applyBtn);

        let currentMobileSelect = null;
        let currentMobileCustomButton = null;

        function closeMobilePanel() {
            overlay.classList.remove('is-open');
            panel.classList.remove('is-open');
            overlay.setAttribute('aria-hidden', 'true');
            panel.setAttribute('aria-hidden', 'true');
            currentMobileSelect = null;
            currentMobileCustomButton = null;
        }

        function applyMobilePanel() {
            const selectedItem = listEl.querySelector('.blog-filters-mobile-dropdown__item--selected');
            if (selectedItem && currentMobileSelect && currentMobileCustomButton) {
                const value = selectedItem.getAttribute('data-value');
                currentMobileSelect.value = value;
                currentMobileCustomButton.textContent = selectedItem.textContent.trim();
                const changeEvent = new Event('change', { bubbles: true });
                currentMobileSelect.dispatchEvent(changeEvent);
            }
            closeMobilePanel();
        }

        overlay.addEventListener('click', closeMobilePanel);
        closeBtn.addEventListener('click', closeMobilePanel);
        applyBtn.addEventListener('click', applyMobilePanel);

        container.appendChild(overlay);
        container.appendChild(panel);

        return {
            overlay: overlay,
            panel: panel,
            titleEl: titleEl,
            listEl: listEl,
            applyBtn: applyBtn,
            closeBtn: closeBtn,
            setCurrent: function(select, customButton) {
                currentMobileSelect = select;
                currentMobileCustomButton = customButton;
            }
        };
    }

    /**
     * Open mobile bottom-sheet for a given select
     */
    function openMobilePanel(select, customButton, mobileEls) {
        mobileEls.setCurrent(select, customButton);

        const options = select.querySelectorAll('option');
        const titleMap = { category: 'Categories' };
        const selectName = select.getAttribute('name') || '';
        mobileEls.titleEl.textContent = titleMap[selectName] || select.getAttribute('aria-label') || 'Select';

        mobileEls.listEl.innerHTML = '';
        options.forEach(function(option) {
            const item = document.createElement('div');
            item.className = 'blog-filters-mobile-dropdown__item';
            item.setAttribute('data-value', option.value);
            if (option.selected) {
                item.classList.add('blog-filters-mobile-dropdown__item--selected');
            } else {
                item.classList.add('blog-filters-mobile-dropdown__item--unselected');
            }
            const radio = document.createElement('div');
            radio.className = 'blog-filters-mobile-dropdown__item-radio';
            const text = document.createElement('span');
            text.textContent = option.textContent;
            item.appendChild(radio);
            item.appendChild(text);

            item.addEventListener('click', function() {
                mobileEls.listEl.querySelectorAll('.blog-filters-mobile-dropdown__item').forEach(function(opt) {
                    opt.classList.remove('blog-filters-mobile-dropdown__item--selected');
                    opt.classList.add('blog-filters-mobile-dropdown__item--unselected');
                });
                item.classList.remove('blog-filters-mobile-dropdown__item--unselected');
                item.classList.add('blog-filters-mobile-dropdown__item--selected');
            });
            mobileEls.listEl.appendChild(item);
        });

        mobileEls.overlay.classList.add('is-open');
        mobileEls.panel.classList.add('is-open');
        mobileEls.overlay.setAttribute('aria-hidden', 'false');
        mobileEls.panel.setAttribute('aria-hidden', 'false');
    }

    /**
     * Create custom dropdown for select elements
     */
    function initCustomDropdowns() {
        const selects = form.querySelectorAll('.blog-filters__select');
        const mobileElements = createMobileDropdownElements();

        selects.forEach(function(select) {
            const dropdownWrapper = select.closest('.blog-filters__dropdown');
            if (!dropdownWrapper) return;

            // Create custom dropdown
            const customDropdown = document.createElement('div');
            customDropdown.className = 'blog-filters__custom-dropdown';

            // Get all options
            const options = select.querySelectorAll('option');
            options.forEach(function(option, index) {
                const item = document.createElement('div');
                item.className = 'blog-filters__custom-dropdown-item';
                if (option.selected) {
                    item.classList.add('blog-filters__custom-dropdown-item--selected');
                } else {
                    item.classList.add('blog-filters__custom-dropdown-item--unselected');
                }

                const radio = document.createElement('div');
                radio.className = 'blog-filters__custom-dropdown-item-radio';

                const text = document.createElement('span');
                text.textContent = option.textContent;

                item.appendChild(radio);
                item.appendChild(text);

                // Handle click
                item.addEventListener('click', function() {
                    // Update select value
                    select.value = option.value;

                    // Update visual state
                    customDropdown.querySelectorAll('.blog-filters__custom-dropdown-item').forEach(function(opt) {
                        opt.classList.remove('blog-filters__custom-dropdown-item--selected');
                        opt.classList.add('blog-filters__custom-dropdown-item--unselected');
                    });
                    item.classList.remove('blog-filters__custom-dropdown-item--unselected');
                    item.classList.add('blog-filters__custom-dropdown-item--selected');

                    // Update select text
                    const selectText = select.options[select.selectedIndex].textContent;

                    // Close dropdown
                    customDropdown.classList.remove('blog-filters__custom-dropdown--open');
                    dropdownWrapper.classList.remove('blog-filters__dropdown--open');

                    // Trigger change event
                    const changeEvent = new Event('change', { bubbles: true });
                    select.dispatchEvent(changeEvent);
                });

                customDropdown.appendChild(item);
            });

            dropdownWrapper.appendChild(customDropdown);

            // Create custom button to replace select visually
            const customButton = document.createElement('button');
            customButton.type = 'button';
            customButton.className = 'blog-filters__select-custom-button';
            customButton.textContent = select.options[select.selectedIndex].textContent;
            customButton.setAttribute('aria-label', select.getAttribute('aria-label') || 'Select option');

            // Insert custom button before select
            select.parentNode.insertBefore(customButton, select);

            // Hide native select but keep it functional
            select.classList.add('blog-filters__select--hidden');

            // Handle button click
            customButton.addEventListener('click', function(e) {
                e.stopPropagation();

                if (mobileElements && isMobileView()) {
                    // Mobile: open bottom-sheet instead of inline dropdown
                    openMobilePanel(select, customButton, mobileElements);
                    return;
                }

                const isOpen = customDropdown.classList.contains('blog-filters__custom-dropdown--open');

                // Close all other dropdowns
                form.querySelectorAll('.blog-filters__custom-dropdown').forEach(function(dd) {
                    if (dd !== customDropdown) {
                        dd.classList.remove('blog-filters__custom-dropdown--open');
                        const otherWrapper = dd.closest('.blog-filters__dropdown');
                        if (otherWrapper) {
                            otherWrapper.classList.remove('blog-filters__dropdown--open');
                        }
                    }
                });

                // Toggle current dropdown
                if (isOpen) {
                    customDropdown.classList.remove('blog-filters__custom-dropdown--open');
                    dropdownWrapper.classList.remove('blog-filters__dropdown--open');
                } else {
                    customDropdown.classList.add('blog-filters__custom-dropdown--open');
                    dropdownWrapper.classList.add('blog-filters__dropdown--open');
                }
            });

            // Update button text when select changes
            select.addEventListener('change', function() {
                customButton.textContent = select.options[select.selectedIndex].textContent;
            });

            // Close dropdown when clicking outside
            document.addEventListener('click', function(e) {
                if (!dropdownWrapper.contains(e.target) && !customButton.contains(e.target)) {
                    customDropdown.classList.remove('blog-filters__custom-dropdown--open');
                    dropdownWrapper.classList.remove('blog-filters__dropdown--open');
                }
            });
        });
    }

    // Initialize custom dropdowns
    initCustomDropdowns();

    // Handle select changes
    const selects = form.querySelectorAll('.blog-filters__select');
    selects.forEach(function(select) {
        select.addEventListener('change', function(e) {
            e.preventDefault();
            performFilterRequest();
        });
    });

    // Handle search input with debounce
    const searchInput = form.querySelector('.blog-filters__search-input');
    if (searchInput) {
        let searchTimeout;
        searchInput.addEventListener('input', function() {
            clearTimeout(searchTimeout);
            searchTimeout = setTimeout(function() {
                performFilterRequest();
            }, 500);
        });

        // Submit on Enter key
        searchInput.addEventListener('keydown', function(e) {
            if (e.key === 'Enter') {
                e.preventDefault();
                clearTimeout(searchTimeout);
                performFilterRequest();
            }
        });
    }

    // Prevent default form submission
    form.addEventListener('submit', function(e) {
        e.preventDefault();
        performFilterRequest(1);
    });

    // Attach pagination handlers on initial load
    attachPaginationHandlers();
})();
